<!--密码 -->
<template>
  <div>
    <div class="password">
      <p>密码</p>
      <div class="pass-tips" v-show="colors&&password==''">
        <img src="@/assets/img/home/tips.png" class="tips" />
        <span>不能为空</span>
      </div>
    </div>
    <div class="input">
      <div class="phone" :style="{borderColor:colors?'red':'#dedede'}">
        <input
          :type="passWordShow?'text':'password'"
          class="password-input"
          @focus="colors=true"
          @blur="colors=false"
          placeholder="请输入密码"
          v-model="password"
        />
        <img :src="passWordShow?imgs[1]:imgs[0]" class="show" @click="toggle" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations,mapState} from 'vuex'
export default {

  components: {},
  data() {
    return {
      passWordShow: false,
      colors: false,
  
      imgs: [
        require("@/assets/img/home/yinc.png"),
        require("@/assets/img/home/kaiq.png")
      ],
      name:''
      // password:"" //密码
    };
  },
  computed: {
    password:{
      get(){
        return  this.name
      },
      set(val){
        var val=val.replace(/[, ]/g, "")
        this.name=val
        this.getPassword(val)
      },
      
    },
  },
  methods: {
    ...mapMutations(['getPassword']),
    toggle() {
      this.passWordShow = !this.passWordShow;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
// 密码
.password {
  display: flex;
  align-items: center;
  padding: 0.4rem 0 0.2rem;
  p {
    font-size: 0.28rem;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    padding: 0;
  }
  .pass-tips {
    display: flex;
    align-items: center;
    .tips {
      width: 0.22rem;
      height: 0.22rem;
      margin: 0 0.1rem;
    }
    span {
      font-size: 0.22rem;

      font-weight: 400;
      color: rgba(255, 67, 67, 1);
    }
  }
}
.input {
  .phone {
    font-size: 0.28rem;
    display: flex;
    border-bottom: 1px solid #dedede;
    padding: 0.2rem 0;
    align-items: center;
    justify-content: space-between;
    .show {
      width: 0.4rem;
      height: 0.4rem;
    }
    .password-input {
      width: 90%;
    }
    .arrowhead {
      display: flex;
      align-items: center;
      flex: 1;
      .arrowheads {
        width: 0.5rem;
        height: 0.5rem;
        transition: transform 1s;
      }
    }
    .tel {
      flex: 4;
    }
  }
}
</style>